
































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import CharacterIcon from '@/components/parts/CharacterIcon.vue';
import * as api from '@/api/api';
import * as def from '@/common/definitions';
import ArrayUtil from '@/models/common/arrayutil';
import Enumerable from 'linq';

class SkillListItem {
  public constructor(public type: def.CharacterSkillType,
                     public data: api.CharacterSkill) {}
}

@Component({
  components: {
    CharacterIcon,
  },
})
export default class SkillList extends Vue {
  @Prop() public skillPoint!: number;
  @Prop() public skills!: api.CharacterSkill[];
  public skillTypes: SkillListItem[] = [];
  public newSkillTypes: def.CharacterSkillType[] = [];

  @Prop({
    default: () => new def.CharacterSkillType(-1),
  }) public value!: def.CharacterSkillType;

  @Watch('skills')
  public onTypesChanged() {
    this.skillTypes = Enumerable
      .from(this.skills)
      .select((s) => new SkillListItem(
        Enumerable.from(def.CHARACTER_SKILL_TYPES).firstOrDefault((ss) => ss.id === s.type),
        s))
      .toArray();
    this.newSkillTypes = Enumerable
      .from(def.CHARACTER_SKILL_TYPES)
      .where((s) => !Enumerable.from(this.skillTypes).any((ss) => ss.type.id === s.id))
      .where((s) => s.subjectAppear === undefined || s.subjectAppear(this.skills))
      .toArray();
  }
}
